import clsx from "clsx";
import { useLayoutContext } from "./context";
import { Sidebar } from "./components/Sidebar";
import { useSidebarExpansion } from "./components/Sidebar/hooks/useSidebarExpansion";
import { QuickSettings } from "@/components/QuickSettings";
import { Outlet } from "react-router";
import { LiveboardsProvider } from "@/Liveboards";

export function ThoughtSpotLayout() {
  const { headerIsShown } = useLayoutContext();
  const { isSidebarExpanded } = useSidebarExpansion();

  return (
    <LiveboardsProvider>
      <div>
        {!headerIsShown && (
          <div className={clsx("flex items-center pt-4", isSidebarExpanded ? "pl-10" : "pl-8")}>
            <QuickSettings hideArrows={true} hideBusinessName={!isSidebarExpanded} />
          </div>
        )}
        <Sidebar />
      </div>
      <main className="grow mt-4 pr-5 bg-lightGray">
        <Outlet />
      </main>
    </LiveboardsProvider>
  );
}
